import * as React from 'react'
import { classNames } from './helpers'

export interface SuggestedTitlesProps {
  /** The section heading, e.g. "Suggested movies". */
  title: string;
  /** The tiles — one focusable MovieTile per suggestion. */
  children: React.ReactNode;
  className?: string;
}

/**
 * A titled, full-width grid of MovieTiles beneath a detail page — the "Suggested
 * movies" block shared by the watch and news detail pages.
 *
 * Presentational only: each pilet fetches its own related titles and passes the
 * rendered tiles as `children` (their MovieTile arrives from the shell via an
 * extension slot, so it can't be built here). This owns the section, the heading,
 * and the grid — including the reset that turns a row-sized tile into a grid cell,
 * the same neutralisation `.mlsg-titles-wrapper` applies to the favorites grid.
 *
 * Placement (the top margin that separates it from the article above) is the
 * caller's, via `className` — each page seats it a little differently.
 */
export function SuggestedTitles ({ title, children, className }: SuggestedTitlesProps) {
  return (
    <section className={classNames('mlsg-suggested-titles', className)}>
      <h2 className='mlsg-suggested-titles__title'>{title}</h2>
      <div className='mlsg-suggested-titles__grid'>{children}</div>
    </section>
  )
}
